import ProductsTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    ProductsTable
  },
  data() {
    return {
      products: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('products.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.products.index'), route: {}}
    ])
  },
  methods: {
    loadProducts(queryOptions = {}) {
      API.products.index(queryOptions).then(({data, meta}) => {
        this.products = data
        this.meta = meta
      })
    }
  }
})
